// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"egR8J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createPostInteractionLogPayload);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _toConsumableArray = require("@babel/runtime/helpers/toConsumableArray");
var _toConsumableArrayDefault = parcelHelpers.interopDefault(_toConsumableArray);
var _constants = require("../common/constants");
var _config = require("../config");
var _utils = require("../create-payload/common/utils");
var _hiddenTiming = require("../hidden-timing");
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            (0, _definePropertyDefault.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function getParentStack(labelStack) {
    if (!labelStack || labelStack.length <= 1) return null;
    return labelStack.slice(0, labelStack.length - 1);
}
function getSegmentId(labelStack) {
    if (!labelStack) return null;
    var leafLabelStack = labelStack[labelStack.length - 1];
    if ((0, _utils.isSegmentLabel)(leafLabelStack)) return leafLabelStack.segmentId;
    var parentStack = getParentStack(labelStack);
    if (!parentStack) return null;
    return getSegmentId(parentStack);
}
function getParentSegmentId(labelStack) {
    return getSegmentId(getParentStack(labelStack));
}
/**
 * Whenever a render happen, all parent segment have timing reported
 * This method tries to reduce that noise
 */ function removeCascadingParentTimingReport(reactProfilerTimings) {
    var timingIndex = new Map();
    reactProfilerTimings.forEach(function(timing) {
        var segmentId = getSegmentId(timing.labelStack);
        if (segmentId) {
            var _timingIndex$get;
            var timingArray = (_timingIndex$get = timingIndex.get(segmentId)) !== null && _timingIndex$get !== void 0 ? _timingIndex$get : [];
            timingIndex.set(segmentId, timingArray);
            timingArray.push(timing);
        }
    });
    reactProfilerTimings.forEach(function(timing) {
        var parentSegmentId = getParentSegmentId(timing.labelStack);
        if (parentSegmentId) {
            var parentTimings = timingIndex.get(parentSegmentId);
            var filteredParentTimings = parentTimings === null || parentTimings === void 0 ? void 0 : parentTimings.filter(function(parentTiming) {
                if (parentTiming.startTime === timing.startTime && parentTiming.actualDuration === timing.actualDuration) return false;
                return true;
            });
            if (filteredParentTimings) timingIndex.set(parentSegmentId, filteredParentTimings);
            else timingIndex.delete(parentSegmentId);
        }
    });
    return (0, _toConsumableArrayDefault.default)(timingIndex.values()).flatMap(function(v) {
        return v;
    });
}
function transformReactProfilerTimings(reactProfilerTimings) {
    var filtered = removeCascadingParentTimingReport(reactProfilerTimings !== null && reactProfilerTimings !== void 0 ? reactProfilerTimings : []);
    var reactProfilerTimingsMap = filtered.reduce(function(result, _ref) {
        var labelStack = _ref.labelStack, startTime = _ref.startTime, commitTime = _ref.commitTime, actualDuration = _ref.actualDuration, type = _ref.type;
        if (labelStack && type !== 'nested-update') {
            var label = labelStack.map(function(ls) {
                return ls.name;
            }).join('/');
            var start = Math.round(startTime);
            var end = Math.round(commitTime);
            var timing = result.get(label) || {
                labelStack: label,
                startTime: start,
                endTime: end,
                mountCount: 0,
                rerenderCount: 1,
                renderDuration: 0
            };
            if (start < timing.startTime) timing.startTime = Math.round(start);
            if (end > timing.endTime) timing.endTime = Math.round(end);
            if (type === 'mount') timing.mountCount += 1;
            if (type === 'update') timing.rerenderCount += 1;
            timing.renderDuration += Math.round(actualDuration);
            result.set(label, timing);
        }
        return result;
    }, new Map());
    return (0, _toConsumableArrayDefault.default)(reactProfilerTimingsMap.values());
}
function createPostInteractionLogPayload(_ref2) {
    var _window$location;
    var lastInteractionFinish = _ref2.lastInteractionFinish, reactProfilerTimings = _ref2.reactProfilerTimings, lastInteractionFinishVCResult = _ref2.lastInteractionFinishVCResult, postInteractionFinishVCResult = _ref2.postInteractionFinishVCResult;
    var config = (0, _config.getConfig)();
    if (!config) throw Error('UFO Configuration not provided');
    var ufoName = (0, _utils.sanitizeUfoName)(lastInteractionFinish.ufoName);
    var pageVisibilityState = (0, _hiddenTiming.getPageVisibilityState)(lastInteractionFinish.start, lastInteractionFinish.end);
    if (pageVisibilityState !== 'visible') return null;
    var maxEndTimeFromProfiler = reactProfilerTimings ? Math.max.apply(Math, (0, _toConsumableArrayDefault.default)(reactProfilerTimings.map(function(t) {
        return t.commitTime;
    }))) : lastInteractionFinish.end;
    var revisedEndTime = Math.round(maxEndTimeFromProfiler);
    var revisedTtai = Math.round(maxEndTimeFromProfiler - lastInteractionFinish.start);
    var lastInteractionFinishStart = Math.round(lastInteractionFinish.start);
    var lastInteractionFinishEnd = Math.round(lastInteractionFinish.end);
    var lastInteractionFinishTTAI = Math.round(lastInteractionFinish.end - lastInteractionFinish.start);
    var lastInteractionFinishVC90 = null;
    var lastInteractionFinishVCUpdates = [];
    if (lastInteractionFinishVCResult !== null && lastInteractionFinishVCResult !== void 0 && lastInteractionFinishVCResult['ufo:vc:state']) {
        var _lastInteractionFinis;
        lastInteractionFinishVCUpdates = lastInteractionFinishVCResult === null || lastInteractionFinishVCResult === void 0 ? void 0 : lastInteractionFinishVCResult['ufo:vc:updates'];
        var lastInteractionFinishVCMetrics = lastInteractionFinishVCResult === null || lastInteractionFinishVCResult === void 0 ? void 0 : lastInteractionFinishVCResult['metrics:vc'];
        lastInteractionFinishVC90 = (_lastInteractionFinis = lastInteractionFinishVCMetrics[90]) !== null && _lastInteractionFinis !== void 0 ? _lastInteractionFinis : null;
    }
    var postInteractionFinishVCRatios = {};
    var revisedVC90 = null;
    var postInteractionFinishVCUpdates = [];
    if (postInteractionFinishVCResult !== null && postInteractionFinishVCResult !== void 0 && postInteractionFinishVCResult['ufo:vc:state']) {
        postInteractionFinishVCRatios = postInteractionFinishVCResult === null || postInteractionFinishVCResult === void 0 ? void 0 : postInteractionFinishVCResult['ufo:vc:ratios'];
        postInteractionFinishVCUpdates = postInteractionFinishVCResult === null || postInteractionFinishVCResult === void 0 ? void 0 : postInteractionFinishVCResult['ufo:vc:updates'];
        var postInteractionFinishVCMetrics = postInteractionFinishVCResult === null || postInteractionFinishVCResult === void 0 ? void 0 : postInteractionFinishVCResult['metrics:vc'];
        if (typeof lastInteractionFinishVC90 === 'number') {
            var _postInteractionFinis;
            revisedVC90 = (_postInteractionFinis = postInteractionFinishVCMetrics[90]) !== null && _postInteractionFinis !== void 0 ? _postInteractionFinis : null;
        }
    }
    var lateMutations = postInteractionFinishVCUpdates.filter(function(entry, i) {
        return typeof lastInteractionFinishVCUpdates[i] === 'undefined' || entry.time !== lastInteractionFinishVCUpdates[i].time;
    }).map(function(_ref3) {
        var time = _ref3.time, elements = _ref3.elements;
        return {
            time: time,
            elements: Array.from(new Set(elements)).map(function(element) {
                return {
                    element: element,
                    viewportHeatmapPercentage: postInteractionFinishVCRatios[element]
                };
            })
        };
    });
    return {
        actionSubject: 'experience',
        action: 'measured',
        eventType: 'operational',
        source: 'measured',
        tags: [
            'observability'
        ],
        attributes: {
            properties: {
                // basic
                'event:hostname': ((_window$location = window.location) === null || _window$location === void 0 ? void 0 : _window$location.hostname) || 'unknown',
                'event:product': config.product,
                'event:schema': '1.0.0',
                'event:source': {
                    name: 'react-ufo/web',
                    version: (0, _constants.REACT_UFO_VERSION),
                    payloadSource: 'platform'
                },
                'event:region': config.region || 'unknown',
                'experience:key': 'custom.post-interaction-logs',
                postInteractionLog: {
                    lastInteractionFinish: _objectSpread(_objectSpread({}, lastInteractionFinish), {}, {
                        ufoName: ufoName,
                        start: lastInteractionFinishStart,
                        end: lastInteractionFinishEnd,
                        ttai: lastInteractionFinishTTAI,
                        vc90: lastInteractionFinishVC90
                    }),
                    revisedEndTime: revisedEndTime,
                    revisedTtai: revisedTtai,
                    revisedVC90: revisedVC90,
                    lateMutations: lateMutations,
                    reactProfilerTimings: transformReactProfilerTimings(reactProfilerTimings)
                }
            }
        }
    };
}

},{"@babel/runtime/helpers/defineProperty":"2DsLZ","@babel/runtime/helpers/toConsumableArray":"gbrKk","../common/constants":"gM7FM","../config":"acZBX","../create-payload/common/utils":"2tBtR","../hidden-timing":"eQE8K","@atlaspack/transformer-js/src/esmodule-helpers.js":"87JRQ"}],"gM7FM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "REACT_UFO_VERSION", ()=>REACT_UFO_VERSION);
var REACT_UFO_VERSION = '1.0.1';

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"87JRQ"}],"2tBtR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@atlaspack/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sanitizeUfoName", ()=>sanitizeUfoName);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
parcelHelpers.export(exports, "isSegmentLabel", ()=>isSegmentLabel);
var sanitizeUfoName = function sanitizeUfoName(name) {
    return name.replace(/_/g, '-');
};
function isSegmentLabel(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}

},{"@atlaspack/transformer-js/src/esmodule-helpers.js":"87JRQ"}]},[], null, "parcelRequire0a87")

//# sourceMappingURL=create-post-interaction-log-payload.51b9b303.js.map
